













import Vue from 'vue';

export default Vue.extend({
  name: 'TeipModal',
  props: {
    title: {
      required: true,
      type: String,
    },
    idModal: {
      required: true,
      type: String,
    },
    size: {
      required: false,
      type: String,
      default: 'md',
      validator(value: string) {
        return ['md', 'lg', 'sm'].includes(value);
      },
    },
    viewModal: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    syncedViewModal: {
      get(): boolean {
        return this.viewModal;
      },
      set(value: boolean) {
        this.$emit('update:viewModal', value);
      },
    },
  },
});
